// extracted by mini-css-extract-plugin
module.exports = {"root":"Step-module__root___1GZDX","video":"Step-module__video___17Ncw","step":"Step-module__step___2-ndH","title":"Step-module__title___1Qa5H","desc":"Step-module__desc___3JxAw"};